export default "__VITE_ASSET__yB0Rjjb1__"